import React from 'react';
import orderBy from 'lodash/orderBy';

import getSort, { sortByName } from 'utils/sorts';

import DebtGridColumns from './DebtGridColumns';
import DebtGridRows from './DebtGridRows';

const DebtRainbow = ({ debts, settings, ...props }) => {
  const { sortDirection, sortMethod } = getSort(settings.sort);
  const sorted = orderBy(debts, [sortMethod, sortByName], [sortDirection, 'asc']);
  return settings.format === 'columns' ? <DebtGridColumns debts={sorted} settings={settings} {...props} /> : <DebtGridRows debts={sorted} settings={settings} {...props} />;
};

export default DebtRainbow;



// WEBPACK FOOTER //
// ./src/components/DebtRainbow/DebtRainbow.js